import { Controller } from "@hotwired/stimulus";

/**
 * Stimulus controller for question row highlight effect.
 * Removes the 'table-new' class after a short delay to animate new rows.
 *
 * @class QuestionController
 * @extends Controller
 */
export default class extends Controller {
  /**
   * Called when the controller is connected to the DOM.
   * Removes the 'table-new' class after 3 seconds for fade-in effect.
   */
  connect() {
    // Remove the highlight class after 3 seconds to trigger a fade-in animation
    setTimeout(() => {
      this.element.classList.remove("table-new");
    }, 3000);
  }

  /**
   * Called when the controller is disconnected from the DOM.
   * (No-op, but included for Stimulus lifecycle completeness.)
   */
  disconnect() {
  }
}
